import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import InsumoRecord from '@components/InsumoRecord/InsumoRecord';
import formatMessage from './i18n/formatMessage';
import Insumo from '@resources/InsumosEnum';

/**
 * Componente para tela de Fertilizantes Quimicos
 *
 * @author Gabriela Farias <gabriela.farias@kepha.com.br>
 * @param {*} props
 * @returns {JSX.Element}
 */
function FertilizantesQuimicos(props) {
  useEffect(() => {
    const title = 'fertilizantesQuimicos.fertilizantesQuimicos';
    if (props.itensState.name !== title) {
      props.dispatch({ type: 'UPDATE_TOOLBAR', toolbar: formatMessage(title), name: title });
    }
  }, []);

  return (
    <InsumoRecord
      chipData={props.chipData}
      infoUsuario={props.infoUsuario}
      insumoEnum={Insumo.FERTILIZANTE_QUIMICO}
      insumoURL='fertilizantes-quimicos'
      viewKey='fertilizantesQuimicos'
      deleteMessageSucess={formatMessage(
        'fertilizantesQuimicos.fertilizantesQuimicosRemovidoComSucesso'
      )}
      mensagemFalhaDeletar={formatMessage('fertilizantesQuimicos.falhaAoExcluirFertilizantesQuimicos')}
      mensagemDelete={formatMessage('fertilizantesQuimicos.desejaExcluir')}
    />
  );
}

const mapStateToProps = state => ({
  itensState: state.toolbar,
  infoUsuario: state.adicionarInfoUsuario.info,
  chipData: state.chips.chipData.filter(date => {
    return date.id === 'fertilizantesQuimicos';
  })[0].content
});

export default connect(mapStateToProps)(FertilizantesQuimicos);
